
import { Component, Vue } from 'vue-property-decorator';
import BasePagina from '@/components/base/BasePagina.vue';
import CardMonitoramento from '@/components/monitoramento/CardMonitoramento.vue';
import { EquipamentoFilter } from '@/shared/models/equipamento/equipamento.filter';
import Format from '@/shared/utils/format.util';
import { PostoTrocaInterface } from '@/shared/models/posto/posto-troca.interface';
import BasePesquisa from '@/components/base/BasePesquisa.vue';
import { MonitoramentoInterface } from '@/shared/models/monitoramento/monitoramento.interface';
import MonitoramentoService from '@/services/monitoramento.service';
import PostoTrocaService from '@/services/posto-troca.service';
import BaseCampos from '@/components/base/BaseCampos.vue';

@Component({
  components: {
    BaseCampos,
    BasePesquisa,
    CardMonitoramento,
    BasePagina,
  },
})
export default class Monitoramento extends Vue {
  public lista: Array<MonitoramentoInterface> = [];

  public statusFilter: string;

  public countStatus = {
    manutencao: 0,
    funcionamento: 0,
    limiteParcial: 0,
    limiteAlcancado: 0,

  };

  public listaFiltro: Array<MonitoramentoInterface> = [];

  public listaCidades: Array<string> = [];

  public listaPonto: Array<PostoTrocaInterface> = [];

  public filtro = {} as EquipamentoFilter;

  public filtroAnterior = null as EquipamentoFilter;

  public atualizarPesquisaInterval;

  public colapses = [
    { titulo: 'Filtragem', nomeSlot: 'pesquisa' },
  ];

  private getFieldText(item: PostoTrocaInterface) {
    if (item.nomeFantasia === null || item.nomeFantasia === undefined) {
      return item.cnpj;
    }
    if (item.cnpj === null) {
      return item.nomeFantasia;
    }
    return `${item.cnpj} - ${item.nomeFantasia}`;
  }

  private limparPesquisa() {
    (this.$refs.formPesquisa as HTMLFormElement).reset();
    this.pesquisar();
    this.statusFilter = null;
  }

  private async filtrarStatus(status: string) {
    this.statusFilter = status;
    let recount = 1;
    if (this.statusFilter === 'Em manutenção') {
      this.listaFiltro = this.lista.filter((e) => e.status === this.statusFilter || e.status === 'OFF');
      this.listaFiltro.forEach((s) => {
        s.cardNumber = recount;
        recount += 1;
      });
      return;
    }
    this.listaFiltro = this.lista.filter((e) => e.status === this.statusFilter);
    this.listaFiltro.forEach((s) => {
      s.cardNumber = recount;
      recount += 1;
    });
  }

  async pesquisar() {
    this.lista = await new MonitoramentoService().buscarPorFiltro(this.filtro);
    this.listaFiltro = this.lista;
    this.count();
    this.setFiltroAnterior(this.filtro);
  }

  async atualizarUltimaPesquisa() {
    this.lista = await new MonitoramentoService().buscarPorFiltro(this.filtroAnterior);
    this.listaFiltro = this.lista;
    this.count();
  }

  count() {
    this.countStatus.manutencao = 0;
    this.countStatus.funcionamento = 0;
    this.countStatus.limiteParcial = 0;
    this.countStatus.limiteAlcancado = 0;
    this.lista.forEach((status) => {
      switch (status.status) {
        case 'Em funcionamento':
          this.countStatus.funcionamento += 1;
          break;
        case 'Limite parcial':
          this.countStatus.limiteParcial += 1;
          break;
        case 'Limite alcançado':
          this.countStatus.limiteAlcancado += 1;
          break;
        case 'Em manutenção':
          this.countStatus.manutencao += 1;
          break;
        case 'OFF':
          this.countStatus.manutencao += 1;
          break;
        default:
          break;
      }
    });
  }

  async buscarTodosPontos() {
    this.listaPonto = (await new PostoTrocaService().buscarTodos()).map((pdv) => {
      pdv.cnpj = Format.cnpj(pdv.cnpj);
      return pdv;
    });
  }

  async rotinaAtualizarPesquisa() {
    this.atualizarPesquisaInterval = setInterval(() => {
      if (this.filtroAnterior !== null) {
        this.atualizarUltimaPesquisa().then(() => {
          if (this.statusFilter !== undefined && this.statusFilter !== null) {
            this.filtrarStatus(this.statusFilter);
          }
        });
      }
    }, 10000);
  }

  setFiltroAnterior(filtro: EquipamentoFilter) {
    this.filtroAnterior = filtro;
  }

  mounted() {
    this.pesquisar().then(() => {
      this.listaCidades = this.lista
        .filter((e) => e.cidade !== undefined)
        .map((e) => e.cidade.trim());
    });
    this.buscarTodosPontos();
    this.rotinaAtualizarPesquisa();
  }

  destroyed() {
    clearInterval(this.atualizarPesquisaInterval);
  }
}
